import { Dialog } from '@angular/cdk/dialog';
import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { EPreloginServiceCode, IAdditionalFields, IResultNavigationDetails, IResultPageState } from '@common/models';
import { HttpRequestPayload, IHttpErrorPayload, IHttpSuccessPayload } from '@core/models';
import { HttpProviderService } from '@core/service';
import { TranslateService } from '@ngx-translate/core';
import { catchError, map, Observable, Subject, throwError } from 'rxjs';
import { CommonService } from 'src/app/common.service';
import { InfoPopupComponent } from 'src/app/core/components/popup/info-popup/info-popup.component';
import { EntryShellService } from 'src/app/pages/entry-shell/services/entry-shell.service';
import { IPopupScreenData } from '../../models/popup-screen-data.model';

@Injectable({
  providedIn: 'root',
})
export class ResultService {
  
  private transactionModules = ["accounts", "debit-cards", "loans", "credit-cards", "deposits"];
  private transferPaymentRetryRoutes = ["OAT","INTBT","ACH","SWIFT"];
  private transferBeneficiaryRetryRoutes = ["bene-INTBT","bene-SWIFT","bene-ACH"];
  private loginModules = ["identity-yourself","otp-auth","reset-password"];
  resultPageUrl: any;
  retryUrl: string[];
  closeUrl: string[];

  reloadFavouriteGrid = new Subject<boolean>();
  resultBaseUrl: string[];
  backUrl: any;
  refNo: any;
  
  constructor(private _httpProvider: HttpProviderService, 
    private _shellService:EntryShellService,
    private _router:Router,
    private _commonService: CommonService,
    public translate: TranslateService,
    private _dialog: MatDialog
    ) {
      
    }
  public additionalFields: IAdditionalFields[];
  private title: string;
  private message: string;
  private alertType: 'Success' | 'Warning' | 'Failed';
  private navigationDtls: IResultNavigationDetails[] ;
  private resultPayload: IHttpSuccessPayload<any> | IHttpErrorPayload;
  private serviceCode : string ;
  private successMsgNumber : string;
  queryParamsData;
  hiddenData;


  setTitle(title: string) {
    this.title = title;
  }

  setService(serviceCode: string) {
    this.serviceCode = serviceCode;
  }

  setResultPayload(resultPayload: IHttpSuccessPayload<any> | IHttpErrorPayload) {
    this.resultPayload = resultPayload;
  }

  setSuccessMsgNumber(successMsgNumber) {
    this.successMsgNumber = successMsgNumber;
  }

  setSuccess(resultPayload,message, additionFields = null, additionNavigation: IResultNavigationDetails[] = null, title = null, defaultBtnRequired = true,hiddenData?){
    this.setResultPayload(resultPayload);
    this.alertType = 'Success';
    let titleText = title?title:EPreloginServiceCode.SUCCCESSFUL;
    this.title = this.translate.instant('RESULTPAGEMESSAGE.TITLE.'+titleText);
    this.message = this.translate.instant('RESULTPAGEMESSAGE.'+message).includes('RESULTPAGEMESSAGE')? message : this.translate.instant('RESULTPAGEMESSAGE.'+message);
    this.hiddenData = hiddenData;
    this.setUrl();
    this.setAdditionNavigations(additionNavigation, defaultBtnRequired);
    this.setAdditionalFields(additionFields);
    if(additionFields){
      this.queryParamsData = additionFields
    }
  }

  setFailure(resultPayload,retryRequired = false, message = null, additionFields = null, additionNavigation: IResultNavigationDetails[] = null, title = null, defaultBtnRequired = true){
    this.setResultPayload(resultPayload);
    this.alertType = 'Failed';
    let titleText = title?title:EPreloginServiceCode.FAILURE_TITLE;
    this.title = this.translate.instant('RESULTPAGEMESSAGE.TITLE.'+titleText);
    let messageText:any;
    if(resultPayload && resultPayload?.error && (resultPayload?.error?.errorMessage || resultPayload?.error?.errorDesc) && (resultPayload?.error?.errorMessage !='' || resultPayload?.error?.errorDesc !='')){
      let error = resultPayload?.error;
      messageText = (error?.errorMessage)?error?.errorMessage:error?.errorDesc;
    }
    else {
      let tempMessageText = message?message:EPreloginServiceCode.FAILURE_MESSAGE;
      messageText = this.translate.instant('RESULTPAGEMESSAGE.'+tempMessageText);
    }
    this.message = messageText;

    this.setUrl(retryRequired);
    this.setAdditionNavigations(additionNavigation, defaultBtnRequired);
    this.setAdditionalFields(additionFields);
  }
 
  setAdditionNavigations(additionNavigation, defaultBtnRequired) {
    if(!additionNavigation) return
    if(!defaultBtnRequired) this.navigationDtls = [];
    additionNavigation.forEach(element => {
      this.navigationDtls.unshift(element);
    });
    if(defaultBtnRequired && additionNavigation) this.navigationDtls[this.navigationDtls.length - 1].btnType = 'link';
  }
  
  setAdditionalFields(additionDetails) {
    if(!additionDetails) return
      this.additionalFields = [];
      let additionalFields: IAdditionalFields;
      for (var key in additionDetails) {
        additionalFields = {
          label: this.translate.instant('RESULTPAGEMESSAGE.ADDITIONALFIELDS.'+key),
          value: additionDetails[key]
        }
        this.additionalFields.push(additionalFields);
      }
  }

  setUrl(retryRequired = null) {
    let currentUrlArray = this._router.url.split('/');
    this.retryUrl = this._router.url.split('/').slice(1);
    let moduleName:string = this._router.url.split('/')[2];
      if(this.transactionModules.includes(moduleName)){
        this.closeUrl = ['home', 'transactions'];
      } else if(moduleName == 'payment') {
        this.closeUrl = ['home', 'transfers'];
      } else if(this.loginModules.includes(moduleName)){
        if(this._router.url.split('/')[1] == 'selfRegister') {
          this.resultBaseUrl = ['selfRegister'];
        }
        this.closeUrl = ['login'];
      } else {
        this.closeUrl = ['home', moduleName];
      }
      // if user comes from overview to open new CA/SA/DA then nav to overview
      let closeUrl = this.backUrl?this.backUrl:this.closeUrl;
      this.navigationDtls = [
        {
          path: closeUrl,
          state: {},
          btnLabel: this.translate.instant('FORM_ACTIONS.close'),
          btnType: 'primary',
        },
      ];
      if(this.alertType == 'Failed') {
        let queryParams;
        if(retryRequired) {
          if(this.transferPaymentRetryRoutes.includes(currentUrlArray[currentUrlArray?.length-1])){
            this.retryUrl = ['home', 'transfers','new-payment'];
            this.hiddenData = null;
          } else if(this.transferBeneficiaryRetryRoutes.includes(currentUrlArray[currentUrlArray?.length-1])){
            let routUrl = this._commonService.isDesktop()?"new-bene":"new-payment"
            this.retryUrl = ['home', 'transfers',routUrl];
            this.hiddenData = null;
            let isManagebene = this.resultPageData?.navigationDtls[0]?.queryParams?.isManageBene?undefined:'addBene'
            if(!isManagebene){
              this.retryUrl = ['home', 'transfers','bene-list'];
            }
            queryParams = { additionalDetails:{"fromNav": isManagebene,"hideFromAccount": true,"closeNav": ["home", "transfers"]} }
          }
          let retryBtn: IResultNavigationDetails = {
            path : this.retryUrl,
            state : {},
            btnLabel : this.translate.instant('FORM_ACTIONS.retry'),
            btnType: 'primary',
            queryParams:queryParams
           };
           this.navigationDtls.unshift(retryBtn);
           this.navigationDtls[1].btnType = 'link';
        }
      }
      // url for result page
      if(this._commonService.isDesktop()) {
        let resultBaseUrl = this.resultBaseUrl?this.resultBaseUrl:this.closeUrl;

        let resultPagePath = [ ...resultBaseUrl, 'result-page' ];
        this.resultPageUrl = resultPagePath;
      }
      else {
        this.resultPageUrl = ['shell','result-page'];
      }
  }

  get resultPageData(): IResultPageState {
    return {
      title: this.title,
      message: this.message,
      alertType: this.alertType,
      navigationDtls: this.navigationDtls,
      resultPayload: this.resultPayload,
      serviceCode : this.serviceCode,
      resultPageUrl: this.resultPageUrl,
      additionalFields: this.additionalFields,
      successMsgNumber: this.successMsgNumber,
      _dialog: this._dialog
    };
  }

  resetResultData() {
    this.title = '';
    this.message = '';
    this.alertType = undefined;
    this.navigationDtls = [];
    this.resultPageUrl = undefined;
    this.retryUrl = undefined;
    this.closeUrl = undefined;
    this.resultPayload = undefined;
    this.serviceCode = '';
    this.additionalFields = undefined;
    this.successMsgNumber = undefined;
    this.resultBaseUrl = undefined;
  }
  
  makeFavoritePayment(): Observable<any> {
    let payload = {};
    payload['favouritepayments'] =  {
      "tranInventoryNo": this.hiddenData?.referenceNumber,
      "beneId":  this.hiddenData?.beneId,
      "accNo":  this.hiddenData?.fromAccountNumber,
      "currency":  this.hiddenData?.paymentCurrency,
      "remarks":  this.hiddenData?.remarks,
      "beneName":this.hiddenData?.paymentMethod=='OAT'?'Your account':this.hiddenData?.beneName,
      "paymentMethod":this.hiddenData?.paymentMethod,
      }
    const httpRequest : HttpRequestPayload = {
      resource : '/favouritepayments',
      method : "POST",
      body: payload
    }
    return this._httpProvider.invokeApi(httpRequest).pipe(map((response : IHttpSuccessPayload<any>) => {
      this.reloadFavouriteGrid.next(true);
      return response.body
    },
    catchError((err : IHttpErrorPayload) => { 
      return throwError(err)
    })));
  }
  makeUnFavoritePayment(currentFavInvNo): Observable<any> {
    const httpRequest : HttpRequestPayload = {
      resource : '/favouritepayments/'+currentFavInvNo,
      method : "DELETE"
    }
    return this._httpProvider.invokeApi(httpRequest).pipe(map((response : IHttpSuccessPayload<any>) => {
      return response.body
    },
    catchError((err : IHttpErrorPayload) => { 
      return throwError(err)
    })));
  }
}
